import adminAppData from './appData';
import adminRuleSet from './ruleSet';

export default {
    adminAppData,
    adminRuleSet,
};
